import React, { useState } from 'react'

import { DataGrid } from '@mui/x-data-grid'
import nanoid from 'nanoid'

import { Alert, AlertTitle, List, ListItem } from '@mui/material'
import _ from 'lodash'
import Container, { Wrapper } from './styles'
import columns from './columns'
import {
  builFinancialPendencydDate,
  formatPendenciesInformantBaseName,
} from "../../../../../utils/financial_situation_utils"


const prepareData = (data) => {
  return data || 'N/A'
}

const createData = (pending, hasDuplicate) => {
  const { expiration_date, contract, value, debtor_type, creditor, informant } = pending
  const processed_expiration_date = builFinancialPendencydDate(expiration_date)
  const processed_contract = prepareData(contract)
  const processed_value = value
  const processed_base = formatPendenciesInformantBaseName(informant)
  return { 
    id: nanoid(),
    expiration_date: processed_expiration_date, 
    contract: processed_contract, 
    value: processed_value,
    hasDuplicate,
    debtor_type, 
    creditor, 
    base: processed_base, 
  }
}


function FinancialPendingsTable(props) {
  const { pendings, totalValue, totalValueWithoutDuplicates } = props
  const [hasAnyDuplicates, setHasAnyDuplicates] = useState(false)

  const pendingHasDuplicate = (pending) => {
    const dups = _.filter(pendings, (p) => p.value === pending.value && p.expiration_date === pending.expiration_date)

    const hasDup = dups.length > 1
    if (hasDup && !hasAnyDuplicates) {
      setHasAnyDuplicates(true)
    }
    return hasDup
  }

  const buildRows = () => {
    return pendings.map((pending) => createData(pending, pendingHasDuplicate(pending)))
  }

  const rows = buildRows(pendings)
  const totalValueUniq = totalValueWithoutDuplicates == null ? totalValue : totalValueWithoutDuplicates


  return (
    <div>
      {hasAnyDuplicates && (
        <div style={{ margin: '10px 0' }}>
          <Alert severity="warning">
            <AlertTitle>Duplicatas encontradas</AlertTitle>
            Detectamos a presença da mesma ocorrência em bases diferentes.
            {totalValueUniq !== totalValue && ' A soma total não considera valores duplicados.'}
          </Alert>

          {(totalValueUniq !== totalValue) && <List>
            <ListItem>
              <b>Valor total: </b>
              &nbsp;
              {totalValueUniq.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })}
            </ListItem>
            <ListItem>
              <b>Valor total (com duplicatas): </b>
              &nbsp;
              {totalValue.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })}
            </ListItem>
          </List>}
        </div>
      )}
      <Container>
        <Wrapper>
          <DataGrid
            autoHeight
            columns={columns}
            rows={rows}
            disableColumnMenu
            disableColumnResize
            sortingOrder={['desc', 'asc']}
          />
        </Wrapper>
      </Container>
    </div>)
}

export default FinancialPendingsTable
